export default __webpack_public_path__ + "static/media/60-min.0f578971.png";